"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const common_buoy_dialog_1 = require("@buoyhealth/common.buoy-dialog");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const uuid_1 = require("uuid");
const styles_1 = require("@mui/material/styles");
const common_buoy_layout_1 = require("@buoyhealth/common.buoy-layout");
const Tipping_1 = __importDefault(require("../Tipping"));
const react_hook_form_1 = require("react-hook-form");
const Form_1 = __importDefault(require("./components/Form"));
const analytics_1 = require("./analytics");
const constants_1 = require("./constants");
const mailchimp_1 = require("./requests/mailchimp");
const utils_1 = require("./utils");
const SurveyThankYou_1 = require("../SurveyThankYou");
const FeedbackCopy_1 = __importDefault(require("../../common/FeedbackCopy"));
const ImageHeader_1 = __importDefault(require("../ImageHeader"));
const HelpfulnessSurvey = ({ canCollectUserEmail, displayDelay, showOnMouseOut, skipCookieCheck, surveyConfig, customTitle, subTitle, renderLargeSubTitle, onSurveyCompletion, shouldHideModal, shouldShowModal, tippingEnabled, tippingModuleData, }) => {
    const r = (0, common_buoy_theme_1.useResponsive)();
    const theme = (0, styles_1.useTheme)();
    const isDesktop = r({ xs: false, md: true });
    const isMounted = (0, react_1.useRef)(true);
    const [isModalVisible, setIsModalVisible] = (0, react_1.useState)(false);
    const [isModalDismissed, setIsModalDismissed] = (0, react_1.useState)(false);
    const [isSubmitted, setIsSubmitted] = (0, react_1.useState)(false);
    const [isValueSelected, setIsValueSelected] = (0, react_1.useState)(false);
    const [isHighestRating, setIsHighestRating] = (0, react_1.useState)(false);
    const [tippingSuccessful, setTippingSuccessful] = (0, react_1.useState)(false);
    const surveyId = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const shouldShowTipping = isHighestRating && tippingEnabled;
    const { control, handleSubmit, setFocus } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            email: "",
            freeText: "",
            multipleChoice: [],
        },
    });
    const showModal = (0, react_1.useCallback)(() => {
        if ((isMounted.current || shouldShowModal) &&
            !isModalVisible &&
            !isModalDismissed) {
            setIsModalVisible(true);
            (0, analytics_1.trackSurveySeen)(surveyId, surveyConfig?.question || "");
        }
    }, [
        isModalDismissed,
        isModalVisible,
        surveyConfig?.question,
        surveyId,
        shouldShowModal,
    ]);
    (0, react_1.useEffect)(() => {
        if (!surveyConfig ||
            (!skipCookieCheck && (0, utils_1.userHasDismissedSurvey)()) ||
            isDesktop === undefined ||
            isModalVisible ||
            isModalDismissed) {
            return;
        }
        setTimeout(() => {
            if (shouldHideModal || shouldShowModal)
                return;
            if (isDesktop && showOnMouseOut && isMounted.current) {
                document.onmouseleave = showModal;
            }
            else {
                showModal?.();
            }
        }, displayDelay === undefined ? constants_1.DEFAULT_DELAY : displayDelay);
        return () => {
            isMounted.current = false;
            document.onmouseleave = null;
        };
    }, [
        displayDelay,
        isDesktop,
        isModalDismissed,
        isModalVisible,
        showModal,
        showOnMouseOut,
        skipCookieCheck,
        surveyConfig,
        shouldHideModal,
        shouldShowModal,
    ]);
    const closeModal = (0, react_1.useCallback)(() => {
        setIsModalVisible(false);
        setIsModalDismissed(true);
        document.onmouseleave = null;
        (0, utils_1.setCookie)();
    }, []);
    const onClose = (0, react_1.useCallback)(() => {
        (0, analytics_1.trackSurveyExited)(surveyId);
        closeModal();
        onSurveyCompletion?.();
    }, [closeModal, onSurveyCompletion, surveyId]);
    const onSubmit = (0, react_1.useCallback)((data) => {
        setIsSubmitted(true);
        if (data.freeText) {
            (0, analytics_1.trackSurveyFreeTextSubmitted)(surveyId, data.freeText);
        }
        if (data.email) {
            (0, analytics_1.trackEmailSubmitted)(surveyId);
            (0, mailchimp_1.submitMailchimpForm)(data.email);
        }
        if (data.multipleChoice) {
            data.multipleChoice.forEach((value) => (0, analytics_1.trackMultipleChoiceAnswerSubmitted)(surveyId, value));
        }
    }, [surveyId]);
    const onValueChange = (0, react_1.useCallback)((value, isBestAnswer) => {
        if (isBestAnswer) {
            setIsHighestRating(true);
        }
        setIsValueSelected(true);
        (0, analytics_1.trackSurveyScoreSelected)(surveyId, value);
    }, [surveyId]);
    const onTippingSuccess = () => {
        onSurveyCompletion?.(true);
        setTippingSuccessful(true);
    };
    // Safe guard against mis-entered data in LD
    if (!surveyConfig || !surveyConfig.question || !surveyConfig.answers) {
        return null;
    }
    const getTitle = () => {
        let title = isSubmitted ? "" : customTitle || surveyConfig.question;
        if (!tippingSuccessful && isSubmitted) {
            title = shouldShowTipping ? tippingModuleData?.config?.title : title;
        }
        return title;
    };
    return ((0, jsx_runtime_1.jsx)(common_buoy_dialog_1.ResponsiveDialog, { PaperProps: {
            sx: {
                maxHeight: "90vh",
                backgroundColor: shouldShowTipping && tippingModuleData && isSubmitted
                    ? tippingModuleData.config.background_color
                    : "#fff",
            },
        }, actions: isSubmitted
            ? undefined
            : [
                {
                    label: FeedbackCopy_1.default.Submit,
                    isCta: true,
                    fullWidth: true,
                    onClick: handleSubmit(onSubmit),
                    "data-testid": "submit-button",
                },
            ], bottomDivider: !isDesktop && isValueSelected, drawerHeight: "auto", drawerContentPadding: isSubmitted && shouldShowTipping ? "24px 16px 36px 16px" : undefined, hideCloseIcon: (isSubmitted && !shouldShowTipping) || tippingSuccessful, maxWidth: 400, modalContentPadding: shouldShowTipping && isSubmitted ? "0" : undefined, modalTitlePadding: shouldShowTipping && isSubmitted ? "24px 0 16px 24px" : undefined, onClose: onClose, open: onSurveyCompletion ? shouldShowModal : isModalVisible, title: getTitle(), topDivider: !isDesktop && isValueSelected && !shouldShowTipping, subTitle: isSubmitted ? "" : subTitle, renderLargeSubTitle: renderLargeSubTitle, children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(common_buoy_layout_1.CollapseAndFade, { baselineDelay: theme.transitions.duration.shorter, show: isSubmitted && !shouldShowTipping, children: [(0, jsx_runtime_1.jsx)(ImageHeader_1.default, { onClose: onClose }), (0, jsx_runtime_1.jsx)(SurveyThankYou_1.LargeText, { children: FeedbackCopy_1.default.ThankYou }), (0, jsx_runtime_1.jsx)(SurveyThankYou_1.Paragraph, { children: FeedbackCopy_1.default.ThankYouParagraph1 })] }), (0, jsx_runtime_1.jsx)(common_buoy_layout_1.CollapseAndFade, { show: !isSubmitted, children: (0, jsx_runtime_1.jsx)(Form_1.default, { answers: surveyConfig.answers, canCollectUserEmail: canCollectUserEmail, control: control, multipleChoice: surveyConfig.multiple_choice, onChange: onValueChange, setFocus: setFocus }) }), (0, jsx_runtime_1.jsx)(common_buoy_layout_1.CollapseAndFade, { show: isSubmitted && shouldShowTipping, children: (0, jsx_runtime_1.jsx)(Tipping_1.default, { stripeApiKey: tippingModuleData?.key, interviewToken: tippingModuleData?.token, customConfig: tippingModuleData?.config, onClose: onClose, onTippingSuccess: onTippingSuccess, variant: "dialog" }) })] }) }));
};
exports.default = HelpfulnessSurvey;
//# sourceMappingURL=index.js.map